<template>
  <div class="status-icon" :class="{ spinning, 'has-label': label, clickable }" :style="pillStyle" v-tooltip="tooltip">
    <vue-feather :type="icon" size="15" :style="color ? { color } : {}" />
    <span v-if="label" class="status-label" :style="color ? { color } : {}">{{ label }}</span>
  </div>
</template>

<script>
import VueFeather from 'vue-feather'

export default {
  name: 'StatusIcon',
  components: { VueFeather },
  props: {
    icon: { type: String, required: true },
    tooltip: { type: String, default: '' },
    color: { type: String, default: null },
    spinning: { type: Boolean, default: false },
    label: { type: String, default: '' },
    clickable: { type: Boolean, default: false }
  },
  computed: {
    pillStyle() {
      if (!this.label || !this.color) return {};
      // color-mix (instead of hex math) so color can be a hex or a CSS var
      // like var(--color-status-success) from theme.css
      return {
        '--pill-bg': `color-mix(in srgb, ${this.color} 10%, transparent)`,
        '--pill-border': `color-mix(in srgb, ${this.color} 25%, transparent)`,
        '--pill-hover-bg': `color-mix(in srgb, ${this.color} 20%, transparent)`,
        '--pill-hover-border': `color-mix(in srgb, ${this.color} 40%, transparent)`
      };
    }
  }
}
</script>

<style scoped>
.status-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  cursor: default;
}

.status-icon.has-label {
  width: auto;
  padding: 4px 10px 4px 7px;
  gap: 5px;
  background: var(--pill-bg, transparent);
  border: 1px solid var(--pill-border, #e5e7eb);
}

.status-icon.clickable {
  cursor: pointer;
}

.status-icon.clickable:hover {
  background: var(--pill-hover-bg, #e5e7eb);
  border-color: var(--pill-hover-border, #d1d5db);
}

.status-label {
  font-size: 0.8125rem;
  font-weight: 600;
  white-space: nowrap;
}

.status-icon.spinning :deep(svg) {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
